import { render, staticRenderFns } from "./base-banner.vue?vue&type=template&id=b1c33f8c&scoped=true"
import script from "./base-banner.vue?vue&type=script&lang=ts"
export * from "./base-banner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c33f8c",
  null
  
)

export default component.exports